/**
 * LeaveDocumentService
 * Service for LeaveDocument entity operations
 * Route: api/leavedocuments
 */
import { CrudService } from '../base/CrudService';
/**
 * LeaveDocumentService
 * Handles leave document CRUD operations
 */
export class LeaveDocumentService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LeaveDocumentService.DEFAULT_SERVICE_PATH,
            basePath: LeaveDocumentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
LeaveDocumentService.DEFAULT_SERVICE_PATH = 'hr';
LeaveDocumentService.BASE_PATH = 'api/leavedocuments';
//# sourceMappingURL=LeaveDocumentService.js.map